/*
 * Code snippet: https://codesandbox.io/s/icy-river-wr0uk
 * Explanation: https://stackoverflow.com/questions/62497110/detect-scroll-direction-in-react-js
 */

import { useEffect, useState } from "react";

const SCROLL_UP = "up";
const SCROLL_DOWN = "down";

const useDetectScrollDirection = (thresholdPixels: number) => {
  const [scrollDir, setScrollDir] = useState<typeof SCROLL_UP | typeof SCROLL_DOWN>();

  useEffect(() => {
    const threshold = thresholdPixels || 0;
    let lastScrollY = window.pageYOffset;
    let ticking = false;

    const updateScrollDir = () => {
      const scrollY = window.pageYOffset;

      if (Math.abs(scrollY - lastScrollY) < threshold) {
        ticking = false;
        return;
      }
      setScrollDir(scrollY > lastScrollY ? SCROLL_DOWN : SCROLL_UP);
      lastScrollY = scrollY > 0 ? scrollY : 0;
      ticking = false;
    };

    const onScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(updateScrollDir);
        ticking = true;
      }
    };

    window.addEventListener("scroll", onScroll);

    return () => window.removeEventListener("scroll", onScroll);
  }, [thresholdPixels, scrollDir]);

  return scrollDir;
};

export default useDetectScrollDirection;
